/* Sevilla bankkiezer — hoort bij snippets/p5-sevilla.liquid
   Drie keuzes: stof onderkant, print rugleuning, lengte. Eén echte foto per
   combinatie. Gebouwd voor telefoon: bolletjes één keer opbouwen, stalen klein
   laden, alleen de foto's van de gekozen kleur vooraf ophalen, en de grote foto
   pas wisselen als hij binnen is (geen witte flits). */
(function () {
  'use strict';

  var wortel = document.querySelector('[data-psv]');
  var configEl = document.querySelector('[data-psv-config]');
  if (!wortel || !configEl) return;

  var cfg;
  try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!cfg.maten || !cfg.maten.length || !cfg.golden.length || !cfg.romi.length) return;

  var $ = function (naam) { return document.querySelector('[data-psv-' + naam + ']'); };

  function geld(cent) {
    return '€ ' + (cent / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function vind(lijst, nr) {
    for (var i = 0; i < lijst.length; i++) { if (lijst[i].nr === nr) return lijst[i]; }
    return null;
  }
  // Shopify-CDN kan bestanden verkleind leveren: een staal van 1 MB wordt zo 10 KB
  function klein(url, px) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
  }
  function labelVan(item, code) {
    if (!item) return '';
    return item.naam.indexOf(code) === 0 ? item.naam : code + ' — ' + item.naam;
  }

  var fotos = {};
  (cfg.fotos || []).forEach(function (f) { fotos[f.golden + '|' + f.romi] = f.foto; });
  function fotoVoor(g, r) { return fotos[g + '|' + r] || ''; }

  var params = new URLSearchParams(window.location.search);
  var staat = {
    golden: params.get('golden') || '56',
    romi: params.get('romi') || '58',
    maatId: 0
  };
  if (!vind(cfg.golden, staat.golden)) staat.golden = cfg.golden[0].nr;
  if (!vind(cfg.romi, staat.romi)) staat.romi = cfg.romi[0].nr;
  var uitUrl = params.get('maat');
  for (var m = 0; m < cfg.maten.length; m++) {
    if (uitUrl && cfg.maten[m].titel.indexOf(uitUrl) === 0) staat.maatId = cfg.maten[m].id;
  }
  if (!staat.maatId) staat.maatId = cfg.maten[Math.min(3, cfg.maten.length - 1)].id;

  // ---- vooraf laden: alleen wat je met één tik kunt bereiken ----
  var geladen = {};
  function laadVoor(url) {
    if (!url || geladen[url]) return;
    geladen[url] = true;
    var i = new Image();
    i.decoding = 'async';
    i.src = url;
  }
  function laadRondom() {
    // de 6 prints bij de gekozen kleur (tik op een print = direct)
    cfg.romi.forEach(function (r) { laadVoor(fotoVoor(staat.golden, r.nr)); });
    // en de gekozen print bij de andere kleuren, maar pas als de browser lucht heeft
    var later = function () { cfg.golden.forEach(function (g) { laadVoor(fotoVoor(g.nr, staat.romi)); }); };
    if (window.requestIdleCallback) requestIdleCallback(later, { timeout: 4000 }); else setTimeout(later, 1500);
  }

  // ---- het grote beeld: pas wisselen als de nieuwe foto er is ----
  var fotoEl = $('foto'), stofbeeld = $('stofbeeld');
  var teller = 0;
  function toonBeeld(g, r) {
    var url = (g && r) ? fotoVoor(g.nr, r.nr) : '';
    var vraag = ++teller;
    if (!url) {
      fotoEl.hidden = true;
      stofbeeld.hidden = false;
      $('blok-onder').style.backgroundImage = g && g.staal ? 'url("' + klein(g.staal, 600) + '")' : 'none';
      $('blok-rug').style.backgroundImage = r && r.staal ? 'url("' + klein(r.staal, 600) + '")' : 'none';
      $('blok-onder-naam').textContent = 'Onderkant · Golden ' + staat.golden;
      $('blok-rug-naam').textContent = 'Rugleuning · Romi ' + staat.romi;
      return;
    }
    stofbeeld.hidden = true;
    fotoEl.hidden = false;
    fotoEl.classList.add('is-laden');
    var lader = new Image();
    lader.decoding = 'async';
    lader.onload = function () {
      if (vraag !== teller) return;           // er is intussen iets anders gekozen
      fotoEl.src = url;
      fotoEl.alt = 'Sevilla eetbank in ' + g.naam + ' met ' + r.naam + ' op de rugleuning';
      fotoEl.classList.remove('is-laden');
      // pas NU de buren ophalen: de gekozen foto krijgt de lijn voor zich alleen
      laadRondom();
    };
    lader.onerror = function () { if (vraag === teller) fotoEl.classList.remove('is-laden'); };
    lader.src = url;
    geladen[url] = true;
  }

  // ---- bolletjes: één keer bouwen, daarna alleen de markering wisselen ----
  var knoppen = { golden: {}, romi: {}, maat: {} };

  function staalKnop(item, rol, bij) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'psv-staal';
    b.setAttribute('aria-label', item.naam);
    var rond = document.createElement('span');
    rond.className = 'psv-staal__rond';
    if (item.staal) {
      var img = document.createElement('img');
      // stalen zijn 5-9 KB: direct laden, dan is er nooit een leeg rondje bij het scrollen door de rij
      img.alt = ''; img.loading = 'eager'; img.decoding = 'async';
      img.width = 56; img.height = 56;
      img.src = klein(item.staal, 160);
      img.onerror = function () { rond.textContent = item.nr; rond.classList.add('psv-staal__rond--leeg'); };
      rond.appendChild(img);
    } else {
      rond.classList.add('psv-staal__rond--leeg');
      rond.textContent = item.nr;
    }
    b.appendChild(rond);
    var naam = document.createElement('span');
    naam.className = 'psv-staal__naam';
    naam.textContent = item.naam;
    b.appendChild(naam);
    b.addEventListener('click', bij);
    return b;
  }

  function bouw() {
    var gRij = $('goldens');
    cfg.golden.forEach(function (item) {
      var b = staalKnop(item, 'Golden', function () { staat.golden = item.nr; teken(); });
      knoppen.golden[item.nr] = b;
      gRij.appendChild(b);
    });
    var rRij = $('romis');
    cfg.romi.forEach(function (item) {
      var b = staalKnop(item, 'Romi', function () { staat.romi = item.nr; teken(); });
      knoppen.romi[item.nr] = b;
      rRij.appendChild(b);
    });
    var maten = $('maten');
    cfg.maten.forEach(function (mt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'psv-maat';
      b.disabled = !mt.beschikbaar;
      b.innerHTML = '<span class="psv-maat__cm"></span><span class="psv-maat__prijs"></span>';
      b.querySelector('.psv-maat__cm').textContent = mt.titel;
      b.querySelector('.psv-maat__prijs').textContent = geld(mt.prijs);
      b.addEventListener('click', function () { staat.maatId = mt.id; teken(); });
      knoppen.maat[mt.id] = b;
      maten.appendChild(b);
    });
  }

  function markeer(groep, actief) {
    Object.keys(groep).forEach(function (k) {
      var aan = String(k) === String(actief);
      groep[k].classList.toggle('is-aan', aan);
      groep[k].setAttribute('aria-pressed', aan ? 'true' : 'false');
    });
  }

  function teken() {
    var g = vind(cfg.golden, staat.golden);
    var r = vind(cfg.romi, staat.romi);
    var huidigeMaat = null;
    cfg.maten.forEach(function (mt) { if (mt.id === staat.maatId) huidigeMaat = mt; });

    toonBeeld(g, r);
    markeer(knoppen.golden, staat.golden);
    markeer(knoppen.romi, staat.romi);
    markeer(knoppen.maat, staat.maatId);

    $('golden-naam').textContent = labelVan(g, 'Golden ' + staat.golden);
    $('romi-naam').textContent = labelVan(r, 'Romi ' + staat.romi);

    var cm = parseInt((huidigeMaat && huidigeMaat.titel) || '0', 10);
    var code = (cfg.codePrefix || 'SEV') + '-' + cm + '-G' + staat.golden + '-R' + staat.romi;
    $('samen-titel').textContent = (g ? g.naam : '') + ' met ' + (r ? r.naam : '') + ' op de rugleuning · ' + (huidigeMaat ? huidigeMaat.titel : '');
    $('samen-stof').textContent = 'Onderkant Golden ' + staat.golden + ' · rugleuning Romi ' + staat.romi;
    $('code').textContent = code;

    vulProp($('prop-onder'), g ? labelVan(g, 'Golden ' + g.nr) : '');
    vulProp($('prop-rug'), r ? labelVan(r, 'Romi ' + r.nr) : '');
    vulProp($('prop-code'), code);
    zetVariant(staat.maatId, huidigeMaat);
    zetUrl(cm);
  }

  function vulProp(el, waarde) {
    if (!el) return;
    if (waarde) { el.value = waarde; el.disabled = false; }
    else { el.value = ''; el.disabled = true; }
  }

  function zetVariant(id, maat) {
    var invoer = document.getElementById('p5p-variant-id');
    if (invoer) invoer.value = id;
    var prijsEl = document.getElementById('p5p-price');
    if (prijsEl && maat) prijsEl.textContent = geld(maat.prijs);
    var knop = document.getElementById('p5p-atc');
    if (knop && maat) {
      knop.disabled = !maat.beschikbaar;
      knop.textContent = maat.beschikbaar ? 'IN WINKELWAGEN — ' + geld(maat.prijs) : 'UITVERKOCHT';
    }
  }

  function zetUrl(cm) {
    if (!window.history || !window.history.replaceState) return;
    var p = new URLSearchParams(window.location.search);
    p.set('golden', staat.golden);
    p.set('romi', staat.romi);
    if (cm) p.set('maat', String(cm));
    window.history.replaceState({}, '', window.location.pathname + '?' + p.toString());
  }

  bouw();
  wortel.hidden = false;
  teken();   // laadRondom volgt vanzelf zodra de eerste foto binnen is
})();
